@if (visible()) {
  @if (branded()) {
    <div
      class="pnkl-spinner-branded tw:fixed tw:inset-0 tw:z-[11000] tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-7 tw:bg-surface-0"
    >
      <svg
        viewBox="0 0 421.8 45.5"
        fill="#23282d"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Pinnakl"
        class="tw:h-auto tw:w-55"
      >
        <path d="M38.8,6.1v33.5H6V6.1H38.8z M44.8,0.1H0v45.5h44.8V0.1L44.8,0.1z" />
        <polygon points="0,45.5 28.8,16.1 44.8,30.5 44.8,45.5" />
        <path
          d="M71.8,0h16.5c3.6,0,6.7,0.4,10.2,3.2c2.7,2.1,4.9,5.9,4.9,10.9c0,6.5-4.9,13.7-14.3,13.7H78.7v17.8h-6.9V0z M78.7,21.2h10.2c5.1,0,7.6-3.8,7.6-7.4c0-3.1-1.2-4.9-2.9-6.1c-1.5-1-2.9-1.3-4.9-1.3h-10V21.2z"
        />
        <path d="M126.4,0h6.9v45.5h-6.9V0z" />
        <path d="M159.5,0h6.5l20.6,32.4h0.1V0h6.9v45.5h-6.5l-20.6-32.4h-0.1v32.4h-6.9V0z" />
        <path d="M219.8,0h6.5l20.6,32.4h0.1V0h6.9v45.5h-6.5l-20.6-32.4h-0.1v32.4h-6.9V0z" />
        <path
          d="M303.5,35.4h-17.3l-3.5,10.2h-7.3L292,0h5.8l16.6,45.5H307L303.5,35.4z M301.6,29.2L295,9.3h-0.1l-6.6,19.9H301.6z"
        />
        <path d="M335.8,0h6.9v23.5h0.1L361.6,0h8.2l-14.6,18l16.1,27.6h-8.2l-12.4-22.3l-8,8.4v13.9h-6.9V0z" />
        <path d="M392.7,0h6.9v39h22.2v6.5h-29.1V0z" />
      </svg>
      <div
        class="pnkl-spinner-branded__ring tw:h-7 tw:w-7 tw:rounded-full tw:border-[3px] tw:border-solid tw:border-p-gray-200 tw:border-t-bluegray-900"
      ></div>
    </div>
  } @else {
    <pinnakl-local-spinner
      backgroundColor="rgba(255, 255, 255, 0.5)"
      classes="tw:fixed!"
      size="130px"
    ></pinnakl-local-spinner>
  }
}
